import type { PropsWithChildren } from "react";
import type { Client } from "./ClientContext";
import { ClientContext } from "./ClientContext";

interface Props {
  client: Client;
}
export const ClientContextProvider = ({ client, children }: PropsWithChildren<Props>) => (
  <ClientContext value={client}>{children}</ClientContext>
);
